import React, { useCallback, useEffect, useRef, useState } from "react";

const CountDown = ({ endDate  }) => {
    const targetDate = new Date(endDate).toISOString().split("T")[0]; // Extract YYYY-MM-DD
    const targetTime = new Date(endDate).toISOString().split("T")[1].split(".")[0]; // Extract HH:mm:ss
   
  const [remaining, setRemaining] = useState({
      jours: 0,
      heures: 0,
      minutes: 0,
      secondes: 0,
    }),
    [isExpired, setIsExpired] = useState(false),
    timer = useRef(null);

  const setDate = useCallback(() => {
    const now = new Date().getTime();
    const countDownDate = new Date(`${targetDate} ${targetTime}`).getTime();

    const distance = countDownDate - now;

    if (distance < 0) {
      clearInterval(timer.current);
      setIsExpired(true);
    } else {
      setRemaining({
        jours: Math.floor(distance / (1000 * 60 * 60 * 24)),
        heures: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        secondes: Math.floor((distance % (1000 * 60)) / 1000),
      });
      setIsExpired(false);
    }
  }, [targetDate, targetTime]);

  useEffect(() => {
    setDate();
    timer.current = setInterval(setDate, 1000);
    return () => clearInterval(timer.current);
  }, [setDate]);
  const padWithZero = (value) => {
    return String(value).padStart(2, "0");
  };

  return (
    <div className="flex flex-col items-center  p-4 rounded-lg w-full max-w-xs">
      {!isExpired && targetDate && targetTime ? (
        <div className="flex space-x-3">
          {Object.entries(remaining).map(([label, value], i) => (
            <div key={i} className="flex flex-col items-center">
              <div className="text-xl font-bold text-white bg-gray-900 px-4 py-2 rounded-lg">
              {padWithZero(value)}
              </div>
              <div className="text-sm font-semibold mt-1 uppercase">{label}</div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-red-500 text-lg font-bold">Expired</p>
      )}
    </div>
  );
};

export default CountDown;